import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { CrawlMode } from '@/lib/crawlApi';

interface CrawlModeSelectProps {
  value: CrawlMode;
  onChange: (mode: CrawlMode) => void;
  disabled?: boolean;
}

export function CrawlModeSelect({ value, onChange, disabled }: CrawlModeSelectProps) {
  return (
    <div className="space-y-2 s3-explr-input-group">
      <Label htmlFor="crawlMode" className="s3-explr-label">
        Chế độ thu thập
      </Label>
      <Select
        value={value}
        onValueChange={(next) => onChange(next as CrawlMode)}
        disabled={disabled}
      >
        <SelectTrigger id="crawlMode" className="s3-explr-input">
          <SelectValue placeholder="Chọn chế độ" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="http">HTTP — trang tĩnh (nhẹ)</SelectItem>
          <SelectItem value="browser">Browser — SPA / JavaScript</SelectItem>
        </SelectContent>
      </Select>
      <p className="text-sm text-gray-500">
        Chọn Browser nếu nội dung chỉ hiện sau khi trang chạy JavaScript.
      </p>
    </div>
  );
}
